// Merges per-area Phase 8 commerce dictionaries into the shared translations.
import { cartDict } from "./cart";
import { checkoutDict } from "./checkout";
import { accountDict } from "./account";
import { ordersDict } from "./orders";
import { paymentDict } from "./payment";

const parts = [cartDict, checkoutDict, accountDict, ordersDict, paymentDict];
export const commerceDict = {
  en: Object.assign({}, ...parts.map((p) => p.en)) as Record<string, string>,
  ar: Object.assign({}, ...parts.map((p) => p.ar)) as Record<string, string>,
};
